import { render, staticRenderFns } from "./PaymentMethodCreateEditModal.vue?vue&type=template&id=70265530"
import script from "./PaymentMethodCreateEditModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports